import { useTiptap } from "@tiptap/react";
import { Braces } from "lucide-react";
import t from "@/lang/lang";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { EditorVariable, editorVariableNodeName } from "./editor-variables";

/**
 * EditorVariableDropdown is a toolbar item inserting one of the
 * `variables` into the editor, as a paragraph of its own.
 */
export function EditorVariableDropdown({
  variables,
}: {
  variables: EditorVariable[];
}) {
  const { editor } = useTiptap();

  if (!editor) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={!editor.isEditable}>
        <Button size="sm" variant="outline">
          <Braces />
          {t("Variable")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {variables.map((variable) => (
          <DropdownMenuItem
            key={variable.name}
            onSelect={() =>
              // a paragraph of its own, since a renderer may replace a
              // paragraph holding only a variable by a block, e.g. a
              // table, which is invalid inside running text
              editor
                .chain()
                .focus()
                .insertContent({
                  type: "paragraph",
                  content: [
                    {
                      type: editorVariableNodeName,
                      attrs: { name: variable.name },
                    },
                  ],
                })
                .run()
            }
          >
            <div className="grid">
              <span>{variable.label}</span>
              {variable.description && (
                <span className="text-muted-foreground text-xs">
                  {variable.description}
                </span>
              )}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
